export default __webpack_public_path__ + "8e5cd80b709eb0b1ed1f8a4b8bbf8072.svg";